import React from 'react'

export default function Text ({ text }) {
  return (
    <div style={{ fontSize: '18px', maxWidth: '1200px', padding: '0.5em 35px' }}>
      {text}
    </div>
  )
}
